// Real-time formatter for an ecosystem's `name` (MOOV-5543), the "client" users type to log in. It keeps what the
// backend accepts (alpha_dash) and lower-cases, as the backend does on every rename: accents are dropped (á → a,
// ñ → n), spaces become hyphens and any other character is removed as it is typed.
export function formatEcosystemName(value) {
  return String(value || '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9_-]/g, '')
}
